import React from 'react'

export const InlineFormatFooter: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <div>{children}</div>
}
